<template>
  <div class="z-40 w-full md:hidden">
    <nav
      id="test"
      ref="navigation"
      class="relative rounded-t-3xl border-t border-t-primary bg-primary transition-colors will-change-transform"
    >
      <ul class="flex items-center">
        <li v-for="navItem in navigationMenu" :key="navItem.title" class="w-1/3">
          <template v-if="navItem?.to">
            <AppRouterLink :to="{ name: navItem.to }" v-slot="{ isActive, navigate }">
              <div
                :id="`${navItem.to}Nav`"
                class="flex size-full flex-col items-center pb-3 pt-5 text-center text-xxs text-icon-tertiary"
                :class="{
                  '!text-icon-error':
                    (!searchIsOpen && isActive) ||
                    navItem?.child?.includes((route?.name as string) || '')
                }"
                :title="navItem.title"
                @click.prevent="onMenuClick(navigate)"
              >
                <UiIcon :name="navItem.icon" class="mb-px size-6" :class="navItem?.iconClasses" />
              </div>
            </AppRouterLink>
          </template>
          <template v-else>
            <button
              type="button"
              class="flex size-full items-center justify-center"
              :title="navItem.title"
              @click="navItem?.handler && navItem.handler()"
            >
              <span
                class="flex size-full flex-col items-center py-5 text-center text-xxs text-icon-tertiary"
                :class="{
                  '!text-icon-error': navItem?.isActive
                }"
              >
                <UiIcon
                  :name="navItem.icon"
                  class="mb-px size-6 pt-1"
                  :class="navItem?.iconClasses"
                />
              </span>
            </button>
          </template>
        </li>
      </ul>
      <ConfirmCity class="absolute bottom-full right-4 mb-2" />
    </nav>
  </div>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { reactive } from 'vue'
import { useRoute } from 'vue-router'
import { ConfirmCity } from '@/4_features/Location'
import { useSearch } from '@/5_entities/Search'
import { AppRouterLink, UiIcon } from '@/6_shared/ui'

const { openSearch, closeSearch } = useSearch()
const { searchIsOpen } = storeToRefs(useSearch())
const navigationMenu = reactive([
  {
    title: 'главная',
    icon: 'home',
    to: 'HomeView'
  },
  {
    title: 'поиск',
    icon: 'magnifying-glass',
    handler: () => (searchIsOpen.value ? closeSearch() : openSearch()),
    isActive: searchIsOpen,
    iconClasses: '-mb-px'
  },
  {
    title: 'настройки',
    icon: 'cog-6-tooth',
    to: 'SettingsView',
    child: ['FAQView']
  }
])

const route = useRoute()

const onMenuClick = (navigateHandler: () => void) => {
  closeSearch()
  navigateHandler()
}
</script>
